import AutoLink from './AutoLink'

export default AutoLink
